import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { useTranslation } from 'react-i18next';
import { useSearchParams, Link } from 'react-router-dom';
import Button from '../components/shared/Button';

const Login: React.FC = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <DotLottieReact
            src="https://lottie.host/80801467-8b5d-4945-96f7-5b243d132777/o8TdI7rKct.lottie"
            loop
            autoplay
          />
          <div>
            {searchParams?.get('error') ? (
              <p className="text-sm text-muted-foreground text-center">
                {searchParams?.get('error')}
              </p>
            ) : (
              <p className="text-sm text-muted-foreground text-center">
                {t('error.unspecified_error')}
              </p>
            )}
          </div>
          <div className="mt-6 flex justify-center">
            <Link to="/">
              <Button>{t('error.go_to_home')}</Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
